/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import docApi from "api";
import { isValidPageIndex } from "selectors/pageSelectors";
import * as stores from "stores";
import { pagesInView, thumbnailsInView } from "selectors/pagedViewSelectors";
import { getAssetURI } from "selectors/documentSelectors";

export const getNumberPageApis = () => {
  function numberPagesWillBegin(token) {
    return docApi.numberPagesWillBegin(getAssetURI(stores), token).then(resp => resp.data);
  }

  function addNumberPage(startPageNum, endPageNum, startPageNumber, fontStyle, position) {
    if (isValidPageIndex(stores, startPageNum - 1) && isValidPageIndex(stores, endPageNum - 1)) {
      return docApi
        .addNumberPage(startPageNum - 1, endPageNum - 1, startPageNumber, fontStyle, position)
        .then(({ data }) => {
          let pagesInViewObj = pagesInView(stores);
          const thumbanilsInViewObj = thumbnailsInView(stores);
          stores.documentStore.reloadPages(pagesInViewObj);
          stores.documentStore.reloadThumbnails(thumbanilsInViewObj);
          return data;
        });
    }
    return Promise.reject("Page number is not valid");
  }

  function docHasHFWB() {
    return docApi.docHasHFWB();
  }

  function removePageNumbers(startPageNum, endPageNum) {
    if (isValidPageIndex(stores, startPageNum - 1) && isValidPageIndex(stores, endPageNum - 1)) {
      return docApi.removePageNumbers(startPageNum - 1, endPageNum - 1).then(({ data }) => {
        let pagesInViewObj = pagesInView(stores);
        const thumbanilsInViewObj = thumbnailsInView(stores);
        stores.documentStore.reloadPages(pagesInViewObj);
        stores.documentStore.reloadThumbnails(thumbanilsInViewObj);
        return data;
      });
    }
    return Promise.reject("Page number is not valid");
  }

  function numberPagesDidEnd(token, domain, onlyReloadPages = false, docHashSelector, useDocHashForThrottling) {
    const reloadPages = () => {
      const pagesInViewObj = pagesInView(stores);
      const thumbanilsInViewObj = thumbnailsInView(stores);
      stores.documentStore.reloadPages(pagesInViewObj);
      stores.documentStore.reloadThumbnails(thumbanilsInViewObj);
    };
    if (onlyReloadPages) return reloadPages();
    return docApi.numberPagesDidEnd(token, domain, docHashSelector, useDocHashForThrottling).then(reloadPages);
  }

  return {
    numberPage: {
      addNumberPage,
      numberPagesWillBegin,
      numberPagesDidEnd,
      docHasHFWB,
      removePageNumbers
    }
  };
};
